import { IShimmerElement, ShimmerElementType } from "@fluentui/react";
import { schemeSkeletonConstants } from "@cayo/core/components/Schemes/SchemeSkeleton/constants";

const {
  COLUMN_GAP,
  DATA_COLUMN_WIDTHS,
  JITTER_RANGE,
  JITTER_ROW_STEP,
  JITTER_COL_STEP,
  MIN_BODY_BAR_WIDTH,
} = schemeSkeletonConstants;

const bodyBarWidth = (rowIndex: number, colIndex: number): number => {
  // Deterministic 0..JITTER_RANGE-1 jitter so rows vary but don't reshuffle on re-render.
  const reduction = (rowIndex * JITTER_ROW_STEP + colIndex * JITTER_COL_STEP) % JITTER_RANGE;
  return Math.max(MIN_BODY_BAR_WIDTH, DATA_COLUMN_WIDTHS[colIndex] - reduction);
};

/**
 * Builds interleaved line + gap shimmer elements. The gap after each cell tops
 * up the remaining column width and adds COLUMN_GAP, so columns align across
 * rows even when bar widths vary. `barWidths` and `columnWidths` are parallel
 * arrays (one entry per cell).
 */
const buildShimmerRow = (
  barWidths: number[],
  columnWidths: number[],
  height: number
): IShimmerElement[] =>
  barWidths
    .flatMap<IShimmerElement>((barWidth, i) => [
      { type: ShimmerElementType.line, width: barWidth, height },
      { type: ShimmerElementType.gap, width: columnWidths[i] - barWidth + COLUMN_GAP, height },
    ])
    .slice(0, -1);

export const schemeSkeletonUtils = { bodyBarWidth, buildShimmerRow };
